/**
 * LIG — conversion tests from the Fetch war room (Mike approved 2026-10-24).
 *
 * 1. QUICK SHOP PINNED BAR (everyone, phones). After a size is picked in Quick
 *    Shop, the price and Add to cart sat ~100 px below an 812 px screen. A bar
 *    pinned to the bottom of the sheet shows the print, sizes, price and arrival
 *    window with Add to cart; it hides while the real button is on screen, and
 *    tapping it scrolls to and presses the real button (so "Added" and Check out
 *    appear where the shopper is looking). Judged by a dated before/after on the
 *    pajama page's visit → cart.
 *
 * 2. SAVE MY CART (Instagram / Facebook / TikTok app browsers only, A/B). Ad
 *    shoppers' pajama carts reached checkout ~1 in 10 times vs ~1 in 3 for email
 *    and direct shoppers: they aren't finishing now. Half of app-browser
 *    shoppers (the "test" group, sticky per browser) see the existing My List
 *    invite under the pay buttons with one button that saves the whole cart to
 *    My List (window.LIGSavedList.saveCart — signed in, or after signing in).
 *    The other half see nothing ("control"). Both groups are counted once per
 *    session (cartsave_seen_test / _control), the cart carries _lig_cartsave so
 *    orders can be told apart, and the test group's steps are counted
 *    (cartsave_shown / _tap / _saved) — the tripwire: if fewer than ~1 in 4 taps
 *    end in a save, sign-in inside the app is the wall.
 *
 * Nothing here changes prices, products or checkout. ?lig_cartsave=test|control
 * forces a group in this browser (for checking; any browser).
 */
(function () {
  'use strict';
  if (window.LIGConvert) return;
  window.LIGConvert = true;
  var ua = navigator.userAgent || '';
  var inApp = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|FB4A|BytedanceWebview|musical_ly|TikTok/i.test(ua);
  var phone = window.matchMedia('(max-width: 749px)');
  function count(event) { try { window.LIGSiteSignals && window.LIGSiteSignals.sendOnce && window.LIGSiteSignals.sendOnce(event); } catch (e) { /* never break the page */ } }
  function css(text) { var s = document.createElement('style'); s.textContent = text; document.head.appendChild(s); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  // ------------------------------------------------------------ 1. Quick Shop bar
  css(
    '.lig-qsbar{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;display:flex;align-items:center;gap:12px;' +
    'padding:12px 16px calc(12px + env(safe-area-inset-bottom,0px));background:#F4F0EA;border-top:1px solid #d9cfbf;' +
    'box-shadow:0 -10px 24px rgba(22,20,15,.12);font-family:inherit;font-size:14px;line-height:1.3;color:#16140F;transform:translateY(110%);transition:transform .2s ease}' +
    '.lig-qsbar.is-on{transform:none}.lig-qsbar__txt{flex:1;min-width:0}.lig-qsbar__t{font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.lig-qsbar__s{color:#5b5446;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.lig-qsbar__go{flex:0 0 auto;padding:14px 18px;border:0;border-radius:4px;background:#16201F;color:#fff;font-family:inherit;font-weight:600;font-size:13px;line-height:1;letter-spacing:.12em;text-transform:uppercase}' +
    '@media (min-width:750px){.lig-qsbar{display:none}}'
  );
  function wireQuickShop(dialog) {
    if (dialog.dataset.ligQsbar) return;
    dialog.dataset.ligQsbar = '1';
    var add = dialog.querySelector('.lsb-qs__add');
    if (!add) return;
    var bar = document.createElement('div');
    bar.className = 'lig-qsbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="lig-qsbar__txt"><div class="lig-qsbar__t"></div><div class="lig-qsbar__s"></div></div><button type="button" class="lig-qsbar__go" tabindex="-1">Add to cart</button>';
    dialog.appendChild(bar);
    var realVisible = true, shownOnce = false;
    function ready() { return /add to cart/i.test(add.textContent || '') && !add.disabled; }
    function paint() {
      var on = phone.matches && dialog.open && ready() && !realVisible;
      bar.classList.toggle('is-on', on);
      if (!on) return;
      if (!shownOnce) { shownOnce = true; count('qsbar_shown'); }
      var title = (dialog.querySelector('.lsb-qs__title') || {}).textContent || '';
      var sizes = [].map.call(dialog.querySelectorAll('.lsb-qs__chips [aria-pressed="true"]'), function (b) { return (b.textContent || '').trim(); }).filter(Boolean);
      var price = ((add.textContent || '').match(/\$[\d,.]+/) || [''])[0];
      var arrive = ((dialog.querySelector('.ship-timeline__range') || {}).textContent || '').replace(/\s+/g, ' ').trim().replace(/^(\w+) (\d+) — \1 (\d+)$/, '$1 $2–$3');
      setText(bar.querySelector('.lig-qsbar__t'), title.trim() + (sizes.length ? ' · ' + sizes.join(', ') : ''));
      setText(bar.querySelector('.lig-qsbar__s'), [price, arrive ? 'arrives ' + arrive : ''].filter(Boolean).join(' · '));
    }
    try {
      new IntersectionObserver(function (es) { realVisible = es[0].isIntersecting; paint(); }, { root: dialog.querySelector('.lsb-qs__panel') || null, threshold: 0.6 }).observe(add);
    } catch (e) { realVisible = false; }
    // Watch the product area only — never the bar itself (its own text changes would
    // re-trigger this observer forever) — plus the dialog's open/closed state.
    var watched = dialog.querySelector('.lsb-qs__panel') || add.parentElement;
    new MutationObserver(paint).observe(watched, { subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'disabled'], childList: true, characterData: true });
    new MutationObserver(paint).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    bar.querySelector('button').addEventListener('click', function () {
      count('qsbar_add');
      add.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(function () { add.click(); }, 250);
    });
    paint();
  }

  // ------------------------------------------------------------ 2. Save my cart
  var group = null;
  if (inApp || /[?&]lig_cartsave=(test|control)/.test(location.search)) {
    try {
      var forced = (location.search.match(/[?&]lig_cartsave=(test|control)/) || [])[1];
      group = forced || localStorage.getItem('lig-cartsave-v1');
      if (group !== 'test' && group !== 'control') group = Math.random() < 0.5 ? 'test' : 'control';
      localStorage.setItem('lig-cartsave-v1', group);
    } catch (e) { group = Math.random() < 0.5 ? 'test' : 'control'; }
  }
  css(
    '.lig-cartsave{margin:14px 0 4px;padding:16px 18px;border:1px solid #d9cfbf;border-radius:12px;background:#F7F2E8;color:#16140F;text-align:left}' +
    '.lig-cartsave__eyebrow{margin:0 0 6px;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#6b6252}' +
    '.lig-cartsave__p{margin:0 0 12px;font-size:15px;line-height:1.4}' +
    '.lig-cartsave__row{display:flex;gap:14px;align-items:center;flex-wrap:wrap}' +
    '.lig-cartsave__go{padding:12px 16px;border:0;border-radius:4px;background:#394B3C;color:#fff;font-family:inherit;font-weight:600;font-size:14px;line-height:1;cursor:pointer}' +
    '.lig-cartsave__go[disabled]{opacity:.6}.lig-cartsave__no{background:none;border:0;padding:4px;color:#6b6252;text-decoration:underline;font-family:inherit;font-size:14px;cursor:pointer}' +
    '.lig-cartsave__done{margin:0;font-size:15px}.lig-cartsave__done a{color:inherit}'
  );
  function dismissed() { try { return Number(localStorage.getItem('lig-cartsave-dismissed-v1')) > Date.now() - 7 * 864e5; } catch (e) { return false; } }
  // A personalized line (ornament, card, calendar, book, Make It Theirs, a cuff name) has its own save, and My List
  // can't hold its design, so the box stays out of those carts and off maker pages — in both groups, so the A/B
  // still compares like with like (Mike, 2026-10-27: it was asking ornament shoppers to save twice).
  var makerCart = null, makerCheck = 0;
  function checkMakerCart() {
    var n = ++makerCheck; makerCart = 'pending';
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (n !== makerCheck) return;
      makerCart = (cart.items || []).some(function (i) { return i.properties && Object.keys(i.properties).some(function (k) { return i.properties[k] !== null && i.properties[k] !== ''; }); });
      scan();
    }).catch(function () { if (n === makerCheck) makerCart = true; });
  }
  function placeCartSave() {
    if (!group) return;
    var co = document.querySelector('cart-drawer-component [name="checkout"], .cart-drawer [name="checkout"]');
    if (!co || !co.offsetParent) { makerCart = null; return; }
    if (document.querySelector('.lig-om, .lig-dm, .lig-calendar, .lig-book')) return;
    if (makerCart === null) { checkMakerCart(); return; }
    if (makerCart !== false) return;
    count(group === 'test' ? 'cartsave_seen_test' : 'cartsave_seen_control');
    try { window.LIGSiteSignals && window.LIGSiteSignals.tag && window.LIGSiteSignals.tag({ _lig_cartsave: group }); } catch (e) { /* ok */ }
    if (group !== 'test' || dismissed() || !window.LIGSavedList || !window.LIGSavedList.ready()) return;
    var drawer = co.closest('cart-drawer-component, .cart-drawer') || document;
    if (drawer.querySelector('.lig-cartsave')) return;
    var anchor = drawer.querySelector('shopify-accelerated-checkout-cart, .additional-checkout-buttons') || co;
    var box = document.createElement('aside');
    box.className = 'lig-cartsave';
    box.setAttribute('aria-label', 'Save your cart for later');
    var signedIn = window.LIGSavedList.signedIn && window.LIGSavedList.signedIn();
    box.innerHTML = '<p class="lig-cartsave__eyebrow">A little help from LIG</p>' +
      '<p class="lig-cartsave__p">Still gathering everyone’s sizes? Save this cart to My List and finish whenever you’re ready, on any device.</p>' +
      '<div class="lig-cartsave__row"><button type="button" class="lig-cartsave__go"></button><button type="button" class="lig-cartsave__no">Not now</button></div>';
    var go = box.querySelector('.lig-cartsave__go');
    go.textContent = signedIn ? 'Save my cart' : 'Sign in & save my cart';
    anchor.insertAdjacentElement('afterend', box);
    count('cartsave_shown');
    box.querySelector('.lig-cartsave__no').addEventListener('click', function () {
      try { localStorage.setItem('lig-cartsave-dismissed-v1', String(Date.now())); } catch (e) { /* ok */ }
      box.remove();
    });
    go.addEventListener('click', async function () {
      count('cartsave_tap');
      go.disabled = true;
      try {
        var n = await window.LIGSavedList.saveCart('concierge');
        if (n > 0) done(box, n);
        else if (n === 0) { go.disabled = false; }
        // -1: on the way to sign in; the save finishes when they come back.
      } catch (e) { go.disabled = false; }
    });
  }
  function done(box, n) {
    count('cartsave_saved');
    if (!box) return;
    box.innerHTML = '<p class="lig-cartsave__done">✓ ' + (n === 1 ? 'Saved' : n + ' pieces saved') + ' to <a href="/pages/my-list">My List</a>. They’ll be there on any device.</p>';
  }
  // Back from sign-in: My List finishes the saves and says so.
  document.addEventListener('lig:list-saved-many', function (e) { if (e.detail && e.detail.placement === 'concierge' && e.detail.count > 0) done(document.querySelector('.lig-cartsave'), e.detail.count); });

  // ------------------------------------------------------------ watch the page
  var queued = false;
  function scan() {
    queued = false;
    var qs = document.querySelector('dialog.lsb-qs');
    if (qs) wireQuickShop(qs);
    placeCartSave();
  }
  new MutationObserver(function (ms) {
    if (queued) return;
    for (var i = 0; i < ms.length; i++) {
      var t = ms[i].target;
      if (t && t.closest && t.closest('.lig-qsbar, .lig-cartsave')) continue; // our own UI
      queued = true; setTimeout(scan, 200); return;
    }
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
  document.addEventListener('lig:saved-list-ready', scan);
  scan();
})();
